export const EXTENSION_PROTOCOLS = [
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
  'ms-browser-extension://',
]

export const IGNORED_EXTENSION_MESSAGES = ['Failed to connect to MetaMask', 'MetaMask extension not found']
